/* eslint-disable */

/** unique or primary key constraints on table "argo.connection_kind" */
export enum ArgoConnectionKindConstraint {
  /** unique or primary key constraint on columns "kind" */
  ArgoConnectionKindPkey = 'argo_connection_kind_pkey'
}

export enum ArgoConnectionKindEnum {
  IoLinkMaster = 'ioLinkMaster',
  MqttBroker = 'mqttBroker',
  OpenProtocol = 'openProtocol',
  Ptl110PickLight = 'ptl110PickLight',
  Serial = 'serial',
  TcpClient = 'tcpClient',
  TcpServer = 'tcpServer',
  TorqueTool = 'torqueTool',
  UdpSocket = 'udpSocket'
}

/** select columns of table "argo.connection_kind" */
export enum ArgoConnectionKindSelectColumn {
  /** column name */
  Kind = 'kind'
}

/** update columns of table "argo.connection_kind" */
export enum ArgoConnectionKindUpdateColumn {
  /** column name */
  Kind = 'kind'
}

